import { siteData } from '@/mocks/siteData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-label mb-3">
            <i className="ri-play-circle-line"></i>精彩视频
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            爆料视频 · 现场直击
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            实拍视频还原真相，给你最直观的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {siteData.media.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] bg-background-200 overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-50 text-[10px] font-label">
                  {item.duration}
                </div>
              </div>

              <div className="p-4">
                <h3 className="font-label text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}次播放
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}